import type { FaireProductEntity } from "../../entity_types/product";

export const p_pkg48vcrsd: FaireProductEntity = {
  token: "p_pkg48vcrsd",
  type: "product",
  name: "Handcrafted Easter Egg Soy Candle – Set of 3 Bunny Candles",
  brandToken: "b_e83hfh69gc",
  brandName: "Kristina Bakardina",
  imageUrl:
    "https://cdn.faire.com/fastly/89d300d3098b500a968029243e5a468b0c7e4c6cf5b4f407b08376f907541cd9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc20a378318167e1a0f9755148e146a21f363b19f0ffc1b16dad1478c0ec76ae.png",
  ],
  priceDollars: 15,
  description:
    "Celebrate spring with this charming set of three handcrafted Easter egg candles, each decorated with a delicate bunny design. Made from natural soy wax, these sculptural candles are designed to bring a soft seasonal touch to any home, boutique display, or Easter table setting.\n\nEach candle features a unique bunny motif and pastel details, making the set perfect for spring décor, Easter baskets, holiday gifts, and retail displays.\n\nThese candles are especially popular for:\n\nEaster home décor collections\n\nSpring gift shops\n\nSeasonal boutique displays\n\nEaster basket fillers\n\nHoliday table styling\n\nProduct Details\n• Set of 3 Easter egg candles\n• Hand-poured natural soy wax\n• Bunny relief design in soft pastel colors\n• Elegant spring décor piece\n• Made in small batches\n\nPerfect for retailers looking for unique artisan Easter décor with a playful, modern aesthetic.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:43.377Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
